var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "pt-0 ptHeader mainBackVaillant widthFull mb-5 pb-5 " },
    [
      _vm.loadingState ? _c("loading") : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "container  mb-5" }, [
        _vm._m(0),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "row justify-content-center vaillantCont pt-5" },
          [
            _c(
              "div",
              { staticClass: "col-md-6 pl-5 " },
              [
                _vm._m(1),
                _vm._v(" "),
                _c("br"),
                _vm._v(" "),
                _c("img", {
                  staticClass: "wa_icon mr-3",
                  attrs: { src: require("../../assets/images/wa.png") }
                }),
                _vm._v(" "),
                _c("font-awesome-icon", {
                  staticClass: "green mr-3",
                  class: { redHSD: _vm.brand == "HAPPYBONUS" },
                  attrs: { icon: "headset", size: "2x" }
                }),
                _vm._v(" "),
                _c("font-awesome-icon", {
                  staticClass: "green mr-3",
                  class: { redHSD: _vm.brand == "HAPPYBONUS" },
                  attrs: { icon: "envelope", size: "2x" }
                }),
                _vm._v(" "),
                _c("br"),
                _vm._v(" "),
                _c("br"),
                _vm._v("  al numero tel. "),
                _c("b", {
                  domProps: {
                    innerHTML: _vm._s(
                      _vm.brand == "CHEBONUS" ? _vm.phone : _vm.phone_hsd
                    )
                  }
                }),
                _vm._v(" "),
                _c("br"),
                _c("br"),
                _vm._v("oppure inviaci una mail a "),
                _c("b", {
                  domProps: {
                    innerHTML: _vm._s(
                      _vm.brand == "CHEBONUS" ? _vm.email : _vm.email_hsd
                    )
                  }
                }),
                _vm._v(" "),
                _c("br"),
                _c("br"),
                _vm._v(" disponibili "),
                _vm._m(2),
                _vm._v(" "),
                _c("br"),
                _vm._v(" esclusi i giorni festivi\r\n\r\n\r\n        ")
              ],
              1
            ),
            _vm._v(" "),
            _vm._m(3)
          ]
        )
      ])
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "row justify-content-center mb-3 " }, [
      _c("div", { staticClass: "col-md-12 mt-4" }, [
        _c("h2", { staticClass: " ", attrs: { type: "text" } }, [
          _vm._v(" Informazioni e contatti")
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("h4", [
      _vm._v(" Per ogni tua richiesta "),
      _c("br"),
      _vm._v(" non esitare a contattarci ")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("b", [
      _vm._v("dal lunedì al venerdì "),
      _c("br"),
      _vm._v("dalle 09:00-13:00 e 14:00-18:00")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-md-6 " }, [
      _c("div", {}),
      _vm._v(" "),
      _c("img", {
        staticClass: "img-fluid widthFull",
        attrs: { src: require("../../assets/images/contact.jpg") }
      })
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-249074c3", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-249074c3","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/contact/index.vue
// module id = null
// module chunks = 